import { useState, useCallback } from 'react';
import { addListener, removeListener } from 'resize-detector';
import { useEffectRef } from '@huse/effect-ref';
export function useElementResize(callback) {
    const update = useCallback((element) => {
        const notifyResize = (element) => callback(element);
        addListener(element, notifyResize);
        return () => {
            removeListener(element, notifyResize);
        };
    }, [callback]);
    const ref = useEffectRef(update);
    return ref;
}
export function useElementSize() {
    const [size, setSize] = useState();
    const updateSize = useCallback((element) => {
        const size = {
            width: element.offsetWidth,
            height: element.offsetHeight,
        };
        setSize(size);
    }, []);
    const resize = useElementResize(updateSize);
    const observeElementSize = useCallback((element) => {
        resize(element);
        if (element) {
            updateSize(element);
        }
    }, [resize, updateSize]);
    return [observeElementSize, size];
}
//# sourceMappingURL=index.js.map